import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { provideTooltipConfig } from 'ng-primitives/tooltip';

export function providerTooltip(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideTooltipConfig({
      placement: 'top',
      offset: 8,
      shift: true,
      flip: true,
      showDelay: 0,
      hideDelay: 500,
      cooldown: 0,
      showOnOverflow: false,
      useTextContent: false,
      container: document.body,
    }),
  ]);
}
